import React from 'react';
import { RefreshCw } from 'lucide-react';
import { cn } from '@shared/lib/utils';

export interface PageSpinnerProps {
  label?: string;
  className?: string;
}

export const PageSpinner: React.FC<PageSpinnerProps> = ({
  label = 'Loading...',
  className,
}) => {
  return (
    <div
      className={cn(
        'flex min-h-[300px] w-full flex-col items-center justify-center gap-3 p-8 text-muted-foreground',
        className
      )}
      role="status"
      aria-label={label}
    >
      <RefreshCw className="h-6 w-6 animate-spin text-primary" />
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
};
